import $ from 'jquery';

Drupal.behaviors.toggleScroll = {
  attach: function (context) {
    let throttleScroll;
    const $header = $('.header');

    function hasScrolled() {
      let distance = $(window).scrollTop();

      if (distance > 70) {
        $header.addClass('header--compact');
      }
      else {
        $header.removeClass('header--compact');
      }
    }

    $(document).on('scroll', function () {
      clearTimeout(throttleScroll);
      throttleScroll = setTimeout(function () {
        hasScrolled();
    }, 20);  });
  }
}
